
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getPaytype = async () => {
  return await get<ApiResponse<any[]>>("/paytype").then((res)=>{
      return res
    })
};

 